/**
 * Include your custom JavaScript here.
 *
 * ... (leave all the existing comment lines as they are) ...
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Theme-Warenkorb aktualisieren, wenn Recharge den Warenkorb ändert */
(function () {
  var tries = 0;
  function hook() {
    if (!window.RechargePubSub) { if (++tries < 40) setTimeout(hook, 250); return; }
    ['cart:item:update', 'cart:update'].forEach(function (evt) {
      window.RechargePubSub.subscribe(evt, function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
    });
  }
  hook();
})();

/* =====================================================================
   Dosenpfand automatisch im Warenkorb (DPG-Einwegpfand 0,25 € je Dose)
   - Zählt alle Dosen im Warenkorb (Produkttyp "Ready-to-Drink …",
     Variante "12 x 250 ml" / "24 x 250 ml") und hält die Position
     "Pfand (Einweg-Dose)" immer auf genau dieser Anzahl.
   - Läuft beim Laden der Seite, nach jeder Warenkorb-Änderung und
     direkt vor dem Klick auf "Zur Kasse".
   ===================================================================== */
(function () {
  var PFAND_VARIANT_ID = 57527776837897; // Produkt "Pfand (Einweg-Dose)", 0,25 €
  var origFetch = window.fetch.bind(window);
  var running = null;
  var pending = false;
 
  function cansIn(item) {
    if (!item.product_type || item.product_type.indexOf('Ready-to-Drink') !== 0) return 0;
    var m = String(item.variant_title || '').match(/(\d+)\s*x/i);
    return m ? parseInt(m[1], 10) * item.quantity : 0;
  }
 
  function postJson(url, data) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    });
  }
 
  function doSync() {
    return origFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var need = 0, have = 0, keys = [];
        cart.items.forEach(function (it) {
          if (it.variant_id === PFAND_VARIANT_ID) { have += it.quantity; keys.push(it.key); }
          else { need += cansIn(it); }
        });
        if (need === have && keys.length <= 1) return false;
        if (keys.length === 0) {
          return postJson('/cart/add.js', { items: [{ id: PFAND_VARIANT_ID, quantity: need }] }).then(function () { return true; });
        }
        var updates = {};
        keys.forEach(function (k, i) { updates[k] = i === 0 ? need : 0; });
        return postJson('/cart/update.js', { updates: updates }).then(function () { return true; });
      })
      .then(function (changed) {
        if (changed) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      })
      .catch(function (e) { console.warn('[Pfand]', e); });
  }
 
  function sync() {
    if (running) { pending = true; return running; }
    running = doSync().then(function () {
      running = null;
      if (pending) { pending = false; return sync(); }
    });
    return running;
  }
  window.cfPfandSync = sync;
 
  // Nach jeder Warenkorb-Änderung des Themes (oder einer App) neu abgleichen
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(sync, 50); }, function () {});
    }
    return p;
  };
 
  // Vor dem Checkout sicherstellen, dass das Pfand stimmt
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    sync().then(function () { window.location.href = '/checkout'; });
  }, true);
 
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();